import { LabelVal } from "@areahub/common";
import { fShortenNumber, toDate } from "../utils";

export enum IncidentType {
  WF = "Wildfire",
  RX = "Prescribed Fire",
  CX = "Incident Complex",
}

export const parseWildfireCategory = (category: string) => {
  switch (category) {
    case "WF":
      return "Wildfire";

    case "CX":
      return "Complex Fire";

    case "RX":
      return "Prescribed Wildfire";

    default:
      return "Unknown";
  }
};

export interface WildfireDataFormatterKeys {
  incidentName: string;

  description?: string;

  createDate?: string;

  controlDate?: string;

  containmentDate?: string;

  fireCause?: string;

  acres: string[];
  incidentTypeCategory?: string;
  estimatedCostToDate?: string;
  percentContained?: string;
}

export interface FormattedWildfireData {
  incidentName: string;
  description?: string;

  details: LabelVal[];
}

export class WildfireDataFormatter<FormattedWildfireData> {
  dto: any;

  accessors: WildfireDataFormatterKeys;

  constructor(dto: any, accessors: WildfireDataFormatterKeys) {
    this.dto = dto;
    this.accessors = accessors;
  }

  parseVal(accessor?: string) {
    if (accessor) {
      return this.dto[accessor];
    }
    return "";
  }
  parseLabelVal(label: string, val?: any, accessor?: string) {
    if (val) {
      return {
        label,
        value: val,
      };
    }
    if (accessor) {
      return {
        label,
        value: this.dto[accessor],
      };
    }
    return {
      label,
      value: "Unknown",
    };
  }

  get incidentName() {
    return this.dto[this.accessors.incidentName];
  }

  get description() {
    return this.accessors.description
      ? this.dto[this.accessors.description]
      : "";
  }

  get createDate() {
    return toDate(this.parseVal(this.accessors.createDate));
  }

  get controlDate() {
    return toDate(this.parseVal(this.accessors.controlDate));
  }

  get containmentDate() {
    return toDate(this.parseVal(this.accessors.containmentDate));
  }

  get incidentType() {
    const val = this.parseVal(this?.accessors?.incidentTypeCategory);
    return IncidentType[val as keyof typeof IncidentType];
  }

  get fireCause() {
    return this.parseVal(this.accessors.fireCause);
  }

  get percentContained() {
    return this.parseVal(this.accessors.percentContained);
  }

  get acres() {
    let val = "";
    for (const accessor in this.accessors.acres) {
      const v = this.parseVal(accessor);
      if (v) {
        return (val = v);
      }
    }
    return val ? fShortenNumber(val) + " acres" : "";
  }

  get estimatedCostToDate() {
    const val = this.parseVal(this.accessors.estimatedCostToDate);
    return val ? "$" + fShortenNumber(val) : "";
  }

  get details() {
    return [
      this.parseLabelVal("Incident Type", this.incidentType),
      this.parseLabelVal("Start Date", this.createDate),
      this.parseLabelVal("Control Date", this.controlDate),
      this.parseLabelVal("Containment Date", this.containmentDate),
      this.parseLabelVal("Fire Cause", this.fireCause),
      this.parseLabelVal("Acres Burned", this.acres),
      this.parseLabelVal("Estimated Cost", this.estimatedCostToDate),
      this.parseLabelVal(
        "Percent Contained",
        this.percentContained ? this.percentContained + "%" : "Unknown",
      ),
    ].filter((x) => x.value !== "Unknown");
  }
}
